'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = undefined;

var _reduce2 = require('lodash/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _partialRight2 = require('lodash/partialRight');

var _partialRight3 = _interopRequireDefault(_partialRight2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _ary2 = require('lodash/ary');

var _ary3 = _interopRequireDefault(_ary2);

var _reducers;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.updateRefObjs = updateRefObjs;
exports.mergeIndexes = mergeIndexes;
exports.entityPutReducer = entityPutReducer;
exports.entityPutAllReducer = entityPutAllReducer;
exports.updateSubjRef = updateSubjRef;
exports.updateRangeSubjs = updateRangeSubjs;
exports.entityUpdateReducer = entityUpdateReducer;
exports.delAt = delAt;
exports.delRefRange = delRefRange;
exports.delRefsRange = delRefsRange;
exports.delRefRanges = delRefRanges;
exports.delRefsRanges = delRefsRanges;
exports.delRanges = delRanges;
exports.entityDelReducer = entityDelReducer;
exports.putRef = putRef;
exports.putRefs = putRefs;
exports.delRefs = delRefs;

var _capeRedux = require('cape-redux');

var _capeLodash = require('cape-lodash');

var _actions = require('./actions');

var _helpers = require('./helpers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Update `rangeIncludes` values on object entity.


function updateRefObjs(state, item) {
  if ((0, _isEmpty3.default)(item[_helpers.REF])) return state;
  var key = (0, _helpers.getKey)(item);
  var subj = (0, _helpers.pickTypeId)(item);
  var updateRange = (0, _partialRight3.default)(_helpers.setRangeIncludes, subj, key);
  return (0, _reduce3.default)(item[_helpers.REF], (0, _ary3.default)(updateRange, 3), state);
}

function mergeIndexes(oldItem, item) {
  var _extends2;

  if (!oldItem) return item;
  return _extends({}, item, (_extends2 = {}, _defineProperty(_extends2, _helpers.REF, (0, _capeLodash.merge)(oldItem[_helpers.REF], item[_helpers.REF])), _defineProperty(_extends2, _helpers.REFS, (0, _capeLodash.merge)(oldItem[_helpers.REFS], item[_helpers.REFS])), _defineProperty(_extends2, 'rangeIncludes', (0, _capeLodash.merge)(oldItem.rangeIncludes, item.rangeIncludes)), _extends2));
} // Insert or replace entity.


function entityPutReducer(state, item) {
  var path = (0, _helpers.getPath)(item); // I'm not so sure you want to mergeIndexes here? How do you know when to delete?

  var node = mergeIndexes((0, _get3.default)(state, path), item);
  var newState = (0, _capeLodash.setIn)(path, state, node);
  return updateRefObjs(newState, node);
}

function entityPutAllReducer(state, payload) {
  return (0, _reduce3.default)(payload, entityPutReducer, state);
} // An object node was updated. Update predicate values on subject.


function updateSubjRef(state, subj, predicate, obj) {
  var refPath = (0, _helpers.fullRefPath)(subj, predicate);
  if ((0, _get3.default)(state, refPath)) return (0, _capeLodash.setIn)(refPath, state, obj);
  var refsPath = (0, _helpers.fullRefPath)(subj, predicate, obj);
  return (0, _capeLodash.setIn)(refsPath, state, obj);
} // Update `_refs` values on subject entities.


function updateRangeSubjs(state, item) {
  if ((0, _isEmpty3.default)(item.rangeIncludes)) return state;
  var obj = (0, _helpers.pickTypeId)(item);

  function updateSubj(prevState, subjs, predicate) {
    return (0, _reduce3.default)(subjs, function (ste, subj) {
      return updateSubjRef(ste, subj, predicate, obj);
    }, prevState);
  }

  return (0, _reduce3.default)(item.rangeIncludes, updateSubj, state);
}

function entityUpdateReducer(state, item) {
  var path = (0, _helpers.getPath)(item);
  var oldItem = (0, _get3.default)(state, path);
  var newItem = mergeIndexes(oldItem, item);
  var node = (0, _capeLodash.merge)(oldItem, newItem);
  var newState = (0, _capeLodash.setIn)(path, state, node);
  return updateRangeSubjs(updateRefObjs(newState, node), node);
}

function delAt(path, state) {
  var omitKey = path.pop();
  return (0, _capeLodash.setIn)(path, state, (0, _omit3.default)((0, _get3.default)(state, path), omitKey));
}

function delRefRange(state, obj, predicate, subj) {
  return delAt((0, _helpers.rangePath)(obj, predicate, subj), state);
}

function delRefsRange(state, objs, predicate, subj) {
  function delPath(res, obj) {
    var path = (0, _helpers.rangePath)(obj, predicate, subj);
    return delAt(path, res);
  }

  return (0, _reduce3.default)(objs, delPath, state);
} // Remove from all rangeIncludes.


function delRefRanges(state, item) {
  if ((0, _isEmpty3.default)(item[_helpers.REF])) return state;
  return (0, _reduce3.default)(item[_helpers.REF], (0, _ary3.default)((0, _partialRight3.default)(delRefRange, item), 3), state);
}

function delRefsRanges(state, item) {
  if ((0, _isEmpty3.default)(item[_helpers.REFS])) return state;
  return (0, _reduce3.default)(item[_helpers.REFS], (0, _ary3.default)((0, _partialRight3.default)(delRefsRange, item), 3), state);
}

function delRanges(state, item) {
  if ((0, _isEmpty3.default)(item[_helpers.REF]) && (0, _isEmpty3.default)(item[_helpers.REFS])) return state;
  return delRefsRanges(delRefRanges(state, item), item);
}

function entityDelReducer(state, item) {
  var entity = _extends({}, item, (0, _get3.default)(state, (0, _helpers.getPath)(item)));

  return delAt((0, _helpers.getPath)(item), delRanges(state, entity));
}

function putRef(state, subject, predicate, object) {
  return (0, _capeLodash.setIn)((0, _helpers.fullRefPath)(subject, predicate), state, object);
} // Single vs many?


function putRefs(state, triple) {
  var single = triple.single,
      subject = triple.subject,
      predicate = triple.predicate,
      object = triple.object;
  if (single) return putRef(state, subject, predicate, object);
  var ste1 = (0, _capeLodash.setIn)((0, _helpers.fullRefPath)(subject, predicate, object), state, object);
  return (0, _helpers.setRangeIncludes)(ste1, object, predicate, subject);
}

function delRefs(state, triple) {
  var single = triple.single,
      subject = triple.subject,
      predicate = triple.predicate,
      object = triple.object;
  if (single) return delAt((0, _helpers.fullRefPath)(subject, predicate), state); // @TODO REFS DEL

  return delAt((0, _helpers.fullRefPath)(subject, predicate, object), state);
}

var reducers = exports.reducers = (_reducers = {}, _defineProperty(_reducers, _actions.ENTITY_PUT, entityPutReducer), _defineProperty(_reducers, _actions.ENTITY_UPDATE, entityUpdateReducer), _defineProperty(_reducers, _actions.ENTITY_DEL, entityDelReducer), _defineProperty(_reducers, _actions.ENTITY_PUTALL, entityPutAllReducer), _defineProperty(_reducers, _actions.TRIPLE_DEL, delRefs), _defineProperty(_reducers, _actions.TRIPLE_PUT, putRefs), _reducers);
var reducer = (0, _capeRedux.createReducer)(reducers);
exports.default = reducer;